import { Heading, useTheme } from "@aws-amplify/ui-react";
import { Image } from "@aws-amplify/ui-react";
import React from "react";

export function SignInHeader() {
    const { tokens } = useTheme();

    return (
        <>
            <div className="cubedotsLogo">
                <Image
                    alt="logo"
                    src="/al_shafa.png"
                    padding={tokens.space.medium}
                    width={'40%'}
                    height={'auto'}
                />
            </div>
            <Heading level={3}>
                <h3>Sign in to</h3>
                <h3>your Account</h3>
            </Heading>
        </>
    );
}
